(function (angular) {
    angular.module('bizPartEngage').controller('cleanbase.exthome', extHome);

    extHome.$inject = ['$rootScope', '$window'];

    function extHome($rootScope, $window) {
        var vm = this;

        //const width = 1600;
        const width = screen.width;
        const css = {
            height: width > 1600 ? '60%' : '80%',
            width: width > 1600 ? '60%' : '86%',
            top: '10%',
            left: width > 1600 ? '20%' : '7%',
            boxShadow:
                '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
            borderRadius: '5px',
        };

        $rootScope.$on('WELCOMEGUIDE.COMPLETED', function (e, data) {
            vm.showWelcomeGuide = false;
            $window.parent.postMessage(
                { show: false, dimBackground: false, css: {} },
                '*'
            );
        });

        $rootScope.$on('WELCOMEGUIDE.SHOW', function (e, data) {
            vm.showWelcomeGuide = true;
            var showData = {
                show: true,
                dimBackground: true,
                css: css,
            };
            $window.parent.postMessage(showData, '*');
        });
    }
})(window.angular);
